module.exports = __webpack_public_path__ + "static/media/alertIcon.e5c9a6ee.svg";